<style lang="less" scoped>
  .bid-container {
    display: flex;
    justify-content: space-between;
    padding: 40px;
  }
  .section {
    flex: 1;
    max-width: 800px;
    margin: 0 auto;
    &:nth-of-type(2) {
      margin-left: 40px;
    }
  }
  .section-header {
    display: flex;
    align-items: center;
  }
  .title {
    font-size: 18px;
  }
  .button-group {
    margin-left: 16px;
  }
  .section-body {
    margin-top: 16px;
  }
  .section-box {
    position: relative;
    height: 200px;
    border: 1px solid #e3e3e3;
    border-bottom: 0;
    padding: 40px 16px 16px 16px;
  }
  .cpc-form {
    width: 240px;
    margin-left: calc((100% - 240px) / 2);
  }
  .cpc-input-wrapper {
    position: relative;
  }
  .cpc-input {
    font-size: 18px;
  }
  .cpc-input-prefix {
    font-size: 18px;
    line-height: 50px;
    color: #303030;
    padding-left: 12px;
  }
  .cpc-check-button {
    position: absolute;
    top: 41px;
    right: 7px;
    width: 36px;
    height: 36px;
    border-radius: 3px;
    border: 1px solid #dde1e3;
    background-color: #fff;
    background-image: url(~@/assets/icon-price-check.png);
    background-size: 17px 12px;
    background-position: center;
    background-repeat: no-repeat;
  }
  .table-title {
    position: absolute;
    left: 16px;
    bottom: 16px;
  }
</style>

<style lang="less">
  .sc-management-bid-cpc-form {
    .el-form-item__label {
      width: 100%;
      font-size: 15px;
      color: #7965ef;
      text-align: center;
    }
  }
</style>

<template lang="pug">
  section.bid-container
    .section
      .section-header
        h1.title 광고상태
        el-button-group.button-group
          el-button(:type="activeMobileAd ? 'primary' : undefined", size="mini", @click="toggleMobileAd(true)") ON
          el-button(:type="activeMobileAd ? undefined : 'primary'", size="mini", @click="toggleMobileAd(false)") OFF
      .section-body
        .section-box
          el-form.cpc-form.sc-management-bid-cpc-form(
            :model="form",
            :rules="rules",
            label-positoin="top",
            @submit.native.prevent="submitBiddingCpc")
            el-form-item(label="1클릭 단가 설정 (단위: 10원)", prop="cpc")
              .cpc-input-wrapper
                el-input.cpc-input.lg(v-model="form.cpc" @change="changeCpc")
                  p.cpc-input-prefix(slot="prefix") ₩
                button.cpc-check-button
          p.table-title 입찰 순위
        div(v-loading="loading")
          el-table.table.table-type-2(
            v-if="!loading",
            :data="customers",
            :border="true",
            :row-class-name="tableRowClassName"
          )
            el-table-column(prop="rank", label="순위", align="center", header-align="center")
            el-table-column(prop="storeName", label="상호명", header-align="center")
            el-table-column(label="입찰가", align="right", header-align="center")
              template(slot-scope="scope") {{ scope.row.webCpc | displayPrice }}
</template>

<script>
import { mapState } from 'vuex';
import _ from 'lodash';

export default {
  computed: {
    ...mapState({
      me: state => state.me,
    }),
  },
  async mounted() {
    this.loading = true;
    const cpc = await this.$http.get('/api/mkc/v1/current-cpc-policy');
    if (this.me.stype === 'S' && this.me.sgndr === 'F') {
      this.form.minCpc = cpc.data.data.sohoFemaleWebCpc;
      if (this.form.minCpc > cpc.data.data.sohoFemaleMobCpc) {
        this.form.minCpc = cpc.data.data.sohoFemaleMobCpc;
      }
    } else if (this.me.stype === 'S' && this.me.sgndr === 'M') {
      this.form.minCpc = cpc.data.data.sohoMaleWebCpc;
      if (this.form.cpc > cpc.data.data.sohoMaleMobCpc) {
        this.form.minCpc = cpc.data.data.sohoMaleMobCpc;
      }
    } else if (this.me.stype === 'B') {
      this.form.minCpc = cpc.data.data.brandWebCpc;
    }

    const shop = await this.$http.get('/api/mkc/v1/current-store');
    if (shop.data.data.webAdState !== 'F' || shop.data.data.mobAdState !== 'F') {
      this.activeMobileAd = true;
      this.form.cpc = shop.data.data.webCpc;
    } else {
      this.activeMobileAd = false;
      this.form.cpc = this.form.minCpc;
    }

    await this.listBidding();
    this.loading = false;
  },
  filters: {
    displayPrice(price) {
      return `${price.toLocaleString()}₩`;
    },
  },
  methods: {
    // 비딩 리스트
    async listBidding() {
      const list = await this.$http.get('/api/mkc/v1/current-cpc-bidding', {
        params: {
          type: this.me.stype,
          gndr: this.me.sgndr,
        },
      });
      let count = 0;
      const bidList = [];
      let bidCheck = false;
      list.data.data.forEach((v, k) => {
        v.rank = k + 1;
        if (count < 10) {
          if (this.me.sseq === v.storeSeq) {
            bidCheck = true;
          }
          bidList.push(v);
        }
        if (!bidCheck && v.storeSeq === this.me.sseq) {
          bidList.pop();
          bidList.push(v);
        }
        count += 1;
      });
      this.customers = bidList;
    },
    tableRowClassName({ row }) {
      if (row.storeSeq === this.me.sseq) {
        return 'active';
      }
      return '';
    },
    async toggleMobileAd(flag) {
      // TODO: mobile 광고 toggle API
      try {
        await this.$http.post('/api/mkc/v1/on-off-ad', {
          seq: this.me.sseq,
          flag: flag ? 'O' : 'F',
        });
        this.activeMobileAd = flag;
      } catch (e) {
        this.$alert(e.response.data.message, {
          confirmButtonText: '확인',
        });
      }
    },
    toggleDesktopAd(flag) {
      // TODO: desktop 광고 toggle API
      this.activeDesktopAd = flag;
    },

    // 비딩 submit
    async submitBiddingCpc() {
      try {
        await this.$http.post('/api/mkc/v1/cpc-bidding', {
          host: 'ALL',
          cpc: this.form.cpc,
        });
        this.listBidding();
      } catch (e) {
        this.$alert(e.response.data.message, {
          confirmButtonText: '확인',
        });
      }
    },
    changeCpc(value) {
      this.form.cpc = Math.floor(value / 10) * 10;
    },
  },
  data() {
    const validatePrice = (rule, value, callback) => {
      if (!value) return callback(new Error('1클릭 단가 설정을 입력해주세요.'));
      const numValue = Number(value);
      setTimeout(() => {
        if (_.isNaN(numValue)) {
          callback(new Error('숫자를 입력해주세요.'));
        } else {
          callback();
        }
      }, 1000);
      return true;
    };
    return {
      form: {
        cpc: 20,
        minCpc: 0,
      },
      customers: [],
      activeMobileAd: true,
      activeDesktopAd: true,
      rules: {
        cpc: [
          { validator: validatePrice, trigger: 'blur' },
        ],
      },
      loading: false,
    };
  },
};
</script>
